export interface PicklistOptionLabel {
  label: string;
}

export function orderPicklistAnswerLabelsByDisplay(
  options: PicklistOptionLabel[] | null | undefined,
  labels: string[],
): string[] {
  const displayOrder = Array.isArray(options) ? options.map(option => String(option?.label ?? "")) : [];
  const displayRank = new Map<string, number>();

  displayOrder.forEach((label, index) => {
    if (!displayRank.has(label)) displayRank.set(label, index);
  });

  return labels
    .map((label, index) => ({
      label,
      index,
      rank: displayRank.get(label) ?? displayOrder.length,
    }))
    .sort((left, right) => left.rank - right.rank || left.index - right.index)
    .map(({ label }) => label);
}
